
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, X } from "lucide-react";

interface LeadsSearchBarProps {
  searchQuery: string;
  setSearchQuery: (val: string) => void;
  clearSearch: () => void;
}

const LeadsSearchBar: React.FC<LeadsSearchBarProps> = ({
  searchQuery,
  setSearchQuery,
  clearSearch
}) => {
  return (
    <form
      className="mb-8"
      onSubmit={e => e.preventDefault()}
      role="search"
      aria-label="Search leads"
      autoComplete="off"
    >
      <div className="relative max-w-2xl mx-auto">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground pointer-events-none" />
        <Input
          type="search"
          placeholder="Search by lead name, category, or location..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          className="h-12 pl-12 pr-12 rounded-xl border-border/60 shadow-sm focus-visible:shadow-lg transition-shadow"
        />
        {searchQuery && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 hover:bg-muted/80 transition-all hover:rotate-90"
            onClick={clearSearch}
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </form>
  );
};

export default LeadsSearchBar;
